import * as datastore from '@/datastore'

export interface Household extends datastore.Reference {
	name: string
}

export const defaultHousehold: Readonly<Household> = {
	$id: '',
	name: '',
}
